import * as React from "react";
import { Classes, Overlay, Button, H3, H5, H6, Icon, Intent } from "@blueprintjs/core";
import classNames from "classnames";
import {
    overlayCancelTripContainer, providerContainer, requiredColor, labelContainer, flexRow, displayFlex, trashIconStyle,
    cancelTripTitle, cancelTripSaveButton, footerCancelTrip
} from '../../styles';
import { AppToaster } from "../../toastComponent";
import './overlayStyles.css';
import { CANCEL_TRIP_REASONS, ERROR_TOAST_ICON } from './../../../utils/Constants';
import { patchCancelTrip } from './../../services/tripApiService';


const OVERLAY_EXAMPLE_CLASS = "docs-overlay-example-transition";
const OVERLAY_TALL_CLASS = "docs-overlay-example-tall";


class OverlayCancelTrip extends React.PureComponent {

    state = {
        isLoading: false,
        autoFocus: true,
        canEscapeKeyClose: true,
        canOutsideClickClose: false,
        enforceFocus: true,
        isOpen: true,
        usePortal: true,
        trip: null,
        isConfirmDisabled: true,
        cancelOptions: CANCEL_TRIP_REASONS,
        selectedCancelOption: null,
    };

    handleConfirm = async () => {

        if (this.state.selectedCancelOption === '') {
            AppToaster.show({ message: "* Select an option.", intent: "danger", icon: ERROR_TOAST_ICON, });
            return;
        }

        try {
            this.setState({
                isLoading: true,
            });

            await patchCancelTrip(this.props.tripNumber, this.state.selectedCancelOption);
            AppToaster.show({ message: "Trip canceled successfully.", intent: "success", icon: 'tick', });

        }
        catch (error) {
            console.log(error);
            AppToaster.show({ message: "There was an error. Please try again.", intent: "danger", icon: ERROR_TOAST_ICON, });
        }
        finally {
            this.handleClose();
        }
    }

    handleCancelReasonChange = (event) => {
        var cancelOption = Number(event.target.value);
        this.setState({
            selectedCancelOption: cancelOption,
        })
    }
    handleOpen = () => this.setState({ isOpen: true });
    handleClose = () => {
        this.setState({
            isOpen: false,
            isLoading: false,
        });
        this.props.onModalClosed(this.props.id);
    }



    render() {
        const classes = classNames(
            Classes.CARD,
            Classes.ELEVATION_4,
            OVERLAY_EXAMPLE_CLASS,
            localStorage.getItem("themeName"),
            { [OVERLAY_TALL_CLASS]: this.state.useTallContent },
        );

        return (
            <Overlay className={Classes.OVERLAY_SCROLL_CONTAINER} transitionName={Classes.OVERLAY} onClose={this.handleClose} {...this.state}>
                <div className={classes} style={overlayCancelTripContainer}>
                    <div style={flexRow}>
                        <Icon intent={Intent.DANGER} style={trashIconStyle} icon={'trash'} iconSize={50} />
                        <H5 style={cancelTripTitle}>{this.props.message}</H5>
                    </div>
                    <div>
                        <label style={labelContainer}>
                            <div style={displayFlex}>
                                <div style={providerContainer}>
                                    <H6><strong>Pick a reason for the cancel</strong></H6>
                                    <H3 style={requiredColor}>*</H3>
                                </div>
                                <div className="bp3-input-group .modifier" id="cancelSelect">

                                    <select defaultValue={'DEFAULT'}
                                        id="cancel-options"
                                        className="bp3-input .modifier"
                                        // className={localStorage.getItem("themeName") ? 'options-dark-theme' : ''}
                                        onChange={this.handleCancelReasonChange}
                                    >
                                        <option
                                            disabled
                                            className={localStorage.getItem("themeName") ? 'options-dark-theme bp3-input .modifier' : 'bp3-input .modifier'}
                                            value="DEFAULT">
                                            Select...
                                            </option>
                                        {this.state.cancelOptions.map(cancelOption => {
                                            return (
                                                <option
                                                    className={localStorage.getItem("themeName") ? 'options-dark-theme bp3-input .modifier' : 'bp3-input .modifier'}
                                                    value={cancelOption.value}
                                                    key={cancelOption.name}
                                                >
                                                    {cancelOption.label}
                                                </option>
                                            );
                                        })
                                        }
                                    </select>

                                </div>
                            </div>
                        </label>
                    </div>
                    <br />
                    <div className={Classes.OVERLAY_FOOTER_ACTIONS} style={footerCancelTrip}>
                        <Button intent={Intent.NONE} style={cancelTripSaveButton} onClick={this.handleClose} text="Cancel" disabled={this.state.isLoading} />
                        <Button intent={Intent.DANGER} onClick={this.handleConfirm} text="Yes" loading={this.state.isLoading} />
                    </div>
                </div>
            </Overlay>
        );
    }
}


export default OverlayCancelTrip;
